import React, { useContext as useContextCore } from 'react'
import type { File } from '@ztechapps/common.contract'
import type { ListField, UseListResult } from '@ztechapps/common.hook'
import { useFileList } from '@ztechapps/common.hook'
import type { OnSetFileMetaFunction } from '@ztechapps/webui.input'

export type FileBrowserProviderProps = {
  children: React.ReactNode
  onSetFileMeta?: OnSetFileMetaFunction
  /** Per-field overrides merged onto `FileList`'s default `fieldConfig` — e.g. `{ mimetype: { isVisible: true } }`. */
  fields?: Record<string, Partial<ListField>>
}

export type FileBrowserContext = {
  fileListResult: UseListResult<File>
} & Omit<FileBrowserProviderProps, 'children'>

const context = React.createContext<FileBrowserContext>({} as FileBrowserContext)
const CoreProvider = context.Provider

export const FileBrowserProvider = ({ children, ...props }: FileBrowserProviderProps) => {
  const fileListResult = useFileList()

  return <CoreProvider value={{ fileListResult, ...props }}>{children}</CoreProvider>
}

export const useFileBrowserContext = () => useContextCore(context)
